if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.smsProductFormInitialized = false;
        this.smsProductFormObserver = null;
      }

      connectedCallback() {
        if (this.initializeProductForm()) return;

        this.smsProductFormObserver = new MutationObserver(() => {
          if (!this.initializeProductForm()) return;
          this.smsProductFormObserver.disconnect();
          this.smsProductFormObserver = null;
        });
        this.smsProductFormObserver.observe(this, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        if (!this.smsProductFormObserver) return;
        this.smsProductFormObserver.disconnect();
        this.smsProductFormObserver = null;
      }

      initializeProductForm() {
        if (this.smsProductFormInitialized) return true;

        const form = this.querySelector('form');
        const submitButton = this.querySelector('[type="submit"]');
        const variantIdInput = form && form.querySelector('[name=id]');
        if (!form || !submitButton || !variantIdInput) return false;

        this.form = form;
        this.submitButton = submitButton;
        this.submitButtonText = this.submitButton.querySelector('span');
        variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this), true);

        // Rebuy Smart Cart is authoritative in this theme.
        this.cart = null;

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.smsProductFormInitialized = true;
        return true;
      }

      onSubmitHandler(evt) {
 
        evt.preventDefault();
        // The theme sends the single Shopify cart request, then opens Rebuy.
        // Stop Rebuy's Product Form Redirect listener from submitting it a second time.
        evt.stopImmediatePropagation();
        
// Addon accessories JS 
 if (document.getElementById("metafield-indicator")) {
        // The metafield has a value, so run the code
        document.getElementById("addons_accessoriesproduct_popup").style.display = "block";

        const productDataElement = document.getElementById("product-data");

        if (productDataElement) {
            const productData = JSON.parse(productDataElement.innerText);

            // Assuming `inputValue` holds the current variant ID
            let inputValue = document.querySelector(".product-variant-id").value;
            let variantSKU = '';
            let variantprice = '';

            // Find the variant with the matching ID and retrieve its SKU
            const variant = productData.variants.find(v => v.id == inputValue);
            if (variant) {
                variantSKU = variant.sku;
                variantprice = variant.price;
            }

            // Update the product details section with SKU and other info
            const productDetailsSection = document.getElementById("product-details-section");

            if (productDetailsSection) {
                productDetailsSection.innerHTML = `
                    <div class="current_product_image">
                        <img src="${productData.featured_image}" alt="${productData.title}">
                    </div>
                    <div class="current_product_details_middle">
                        <h2>${productData.title}</h2>
                        <p class="product__sku"><span class="product_sku">SKU: </span>${variantSKU || 'SKU not available'}</p>
                    </div>
                    <div class="current_product_details_last">
                        <p>$${(variantprice / 100).toFixed(2)}</p>
                        <a href="/cart" class="button button--primary">Continue to Cart</a>
                    </div>
                `;
            }
        }
    }
// Addon accessories JS
        
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              const openRebuyCart = () => {
                if (window.SMSRebuyCart && typeof window.SMSRebuyCart.open === 'function') {
                  window.SMSRebuyCart.open();
                } else {
                  window.location = window.routes.cart_url;
                }
              };
              const quickAddModal = this.closest('quick-add-modal');

              if (quickAddModal) {
                let cartOpened = false;
                const openAfterModal = () => {
                  if (cartOpened) return;
                  cartOpened = true;
                  openRebuyCart();
                };
                document.body.addEventListener('modalClosed', openAfterModal, { once: true });
                quickAddModal.hide(true);
                setTimeout(openAfterModal, 500);
              } else {
                openRebuyCart();
              }
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });  
 }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
        
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
